export enum ActiveRackActionTypes {
  SET_RACK = "SET_RACK",
  SET_CELL = "SET_CELL",
  SET_ACTIVE_ALL = "SET_ACTIVE_ALL",
  REMOVE_RACK = "REMOVE_RACK",
  REMOVE_CELL = "REMOVE_CELL",
  REMOVE_ALL = "REMOVE_ALL",
}

export interface ActionActiveRackBase {
  type: ActiveRackActionTypes;
  payload?: any;
}

export interface ActionSetActiveRack extends ActionActiveRackBase {
  readonly payload: string;
}

export interface ActionSetActiveCell extends ActionActiveRackBase {
  readonly payload: string;
}

export interface ActionSetActiveAll extends ActionActiveRackBase {
  readonly payload: {
    cell: string;
    rack: string;
    miner?: string;
  };
}

export interface ActionRemoveRack extends ActionActiveRackBase {}
export interface ActionRemoveCell extends ActionActiveRackBase {}
export interface ActionRemoveAll extends ActionActiveRackBase {}
